var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "license", title: "License" } },
    [
      _c("template", { slot: "copy" }, [
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("License Grant"),
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v(
              "\n      In exchange for the fee the Customer owes under\n      "
            ),
            _c("site-link", { attrs: { to: { hash: "#payment" } } }, [
              _vm._v("Payment"),
            ]),
            _vm._v(
              ", the Company grants the Customer a license, under all the copyrights and any patent rights the\n      Company can license during the term of this agreement, to use Font Awesome Pro as described in\n      "
            ),
            _c(
              "site-link",
              { attrs: { to: { hash: "#what-the-customer-may-do" } } },
              [_vm._v("What the Customer May Do")]
            ),
            _vm._v(",\n      "),
            _c(
              "site-link",
              { attrs: { to: { hash: "#what-creators-may-do" } } },
              [_vm._v("What Creators May Do")]
            ),
            _vm._v(", and\n      "),
            _c(
              "site-link",
              { attrs: { to: { hash: "#what-creators-may-not-do" } } },
              [_vm._v("What Creators May Not Do")]
            ),
            _vm._v(".\n    "),
          ],
          1
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "h5 margin-top-2xl" }, [
          _vm._v("Public Licenses"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      The license granted under this agreement is in addition to, and separate from, the\n      "
          ),
          _c("em", [_vm._v("Company's")]),
          _vm._v("\n      public licenses for\n      "),
          _c("em", [_vm._v("Font Awesome Free")]),
          _vm._v(". This agreement and the public licenses for\n      "),
          _c("em", [_vm._v("Font Awesome Free")]),
          _vm._v(
            "\n      will be read separately, as independent legal documents.\n    "
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }